import { authHeader, router } from '../backend'
import { userService } from '../router'

export const aplManagerService = {
  getTotalAplData,
  getTotalNotice,
  postManagementUserRegistration,
  getManagementUserList,
  getManagementUserInfo,
  putManagementUserPW,
  getSummaryManagementUserList,
  getSummaryManagementUserListView,
  getManagementUserClubName,
  getCustomerNoticeList,
  getCustomerNoticeListView,
  getCustomerNoticeNoticeId,
  getCustomerNoticeTargetsNoticeId,
  putManagementUserModify,
  postNotice,
  putNotice,
  getAccountList,
  getAccountGolfClubs
}

function getTotalAplData () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  return fetch(`${process.env.BASE_API}/home/total-apl?` + Date.now(), requestOptions).then(handleResponse)
}
function getTotalNotice () {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  console.log('-----------getTotalNotice this function called....')
  return fetch(`${process.env.BASE_API}/cs/notice/list?` + Date.now(), requestOptions).then(handleResponse)
}

function postManagementUserRegistration (status, userId, userPw, userName, userPhone, userEmail, userRole, ccode, ccodes) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-cache',
    body: JSON.stringify({ status, userId, userPw, userName, userPhone, userEmail, userRole, ccode, ccodes })
  }
  console.log(requestOptions.body)
  console.log('-----------postManagementUserRegistration this function called....')
  return fetch(`${process.env.BASE_API}/manage/account?` + Date.now(), requestOptions).then(handleResponse)
}

function putManagementUserModify (accountId, status, userName, userRole, userPhone, userEmail, ccode, ccodes) {
  let requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    cache: 'no-cache',
    body: JSON.stringify({ status, userName, userRole, userPhone, userEmail, ccode, ccodes })
  }
  console.log(requestOptions.body)
  console.log('-----------postManagementUserRegistration this functiona called....')
  return fetch(`${process.env.BASE_API}/manage/account/` + accountId, requestOptions).then(handleResponse)
}

function getManagementUserList (Page, Size) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  return fetch(`${process.env.BASE_API}/manage/account/list?pageNo=` + String(Page) + `&pageSize=` + String(Size), requestOptions).then(handleResponse)
}

function getManagementUserInfo (AccountId) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  return fetch(`${process.env.BASE_API}/manage/account/` + AccountId + `?` + Date.now(), requestOptions).then(handleResponse)
}
function putManagementUserPW (AccountId, status, userId, userPw, userName, userPhone, userEmail, userRole, ccode) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-cache',
    body: JSON.stringify({ status, userId, userPw, userName, userPhone, userEmail, userRole, ccode })
  }
  console.log('it is done!')
  return fetch(`${process.env.BASE_API}/manage/account/pw-reset/` + AccountId, requestOptions).then(handleResponse)
}

function getSummaryManagementUserList (Page, Size, status, userRole, searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = ``
  if (status !== undefined && status !== '') {
    queryString = queryString + `&status=${status}`
  }
  if (userRole !== undefined && userRole !== '') {
    queryString = queryString + `&userRole=${encodeURI(userRole)}`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString = queryString + `&searchValue=${encodeURI(searchValue)}`
  }

  return fetch(`${process.env.BASE_API}/manage/account/list?pageNo=` + String(Page) + `&pageSize=` + String(Size) + `${queryString}`, requestOptions).then(handleResponse)
}

function getSummaryManagementUserListView (orderTarget, orderValue, status, userRole, searchValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }

  let queryString = ``
  if (orderTarget !== undefined && orderTarget !== '') {
    queryString = queryString + `&orderTarget=${orderTarget}`
  }
  if (orderValue !== undefined && orderValue !== '') {
    queryString = queryString + `&orderValue=${orderValue}`
  }
  if (status !== undefined && status !== '') {
    queryString = queryString + `&status=${status}`
  }
  if (userRole !== undefined && userRole !== '') {
    queryString = queryString + `&userRole=${encodeURI(userRole)}`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString = queryString + `&searchValue=${encodeURI(searchValue)}`
  }

  return fetch(`${process.env.BASE_API}/manage/account/list-view?pageNo=` + `${queryString}`, requestOptions).then(handleResponse)
}

function getManagementUserClubName () {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  return fetch(`${process.env.BASE_API}/setting/club-info/list/all`, requestOptions).then(handleResponse)
}

function getCustomerNoticeList (Page, Size, searchValue) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  let queryString = ``
  if (searchValue !== undefined && searchValue !== '') {
    queryString = queryString + `&searchValue=${encodeURI(searchValue)}`
  }

  return fetch(`${process.env.BASE_API}/cs/notice/list?pageNo=` + String(Page) + `&pageSize=` + String(Size) + `${queryString}`, requestOptions).then(handleResponse)
}

function getCustomerNoticeListView (pageNo = 1, pageSize, noticeTypeValue, searchValue) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  let queryString = `pageNo=${pageNo}`
  if (pageSize) queryString += `&pageSize=${pageSize}`
  if (noticeTypeValue !== undefined && noticeTypeValue !== '') {
    queryString = queryString + `&noticeTypeValue=${encodeURI(noticeTypeValue)}`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString = queryString + `&searchValue=${encodeURI(searchValue)}`
  }

  return fetch(`${process.env.BASE_API}/cs/notice/list-view?` + `${queryString}`, requestOptions).then(handleResponse)
}

function getCustomerNoticeNoticeId (NoticeId) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  return fetch(`${process.env.BASE_API}/cs/notice/` + NoticeId, requestOptions).then(handleResponse)
}

function getCustomerNoticeTargetsNoticeId (NoticeId) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  return fetch(`${process.env.BASE_API}/cs/notice/notice-target/` + NoticeId, requestOptions).then(handleResponse)
}

function postNotice (noticeType, status, title, content, targetAllYn, targetCcode) {
  let requestOptions = {
    method: 'POST',
    headers: authHeader(),
    cache: 'no-cache',
    body: JSON.stringify({ noticeType, status, title, content, targetAllYn, targetCcode })
  }
  console.log(requestOptions.body)
  console.log('-----------postNotice this function called....')
  return fetch(`${process.env.BASE_API}/cs/notice`, requestOptions).then(handleResponse)
}

function putNotice (noticeId, noticeType, status, title, content, targetAllYn, targetCcode) {
  let requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    cache: 'no-cache',
    body: JSON.stringify({ noticeType, status, title, content, targetAllYn, targetCcode })
  }
  return fetch(`${process.env.BASE_API}/cs/notice/` + noticeId, requestOptions).then(handleResponse)
}

function getAccountList (pageNo, pageSize, status, userRole, searchValue, orderTarget, orderValue) {
  let requestOptions = {
    method: 'GET',
    cache: 'no-cache',
    headers: authHeader()
  }
  let queryString = `?`
  if (pageNo !== undefined && pageNo !== '') {
    queryString += `pageNo=${pageNo}&`
  }
  if (pageSize !== undefined && pageSize !== '') {
    queryString += `pageSize=${pageSize}&`
  }
  if (status !== undefined && status !== '') {
    queryString += `status=${status}&`
  }
  if (userRole !== undefined && userRole !== '') {
    queryString += `userRole=${userRole}&`
  }
  if (searchValue !== undefined && searchValue !== '') {
    queryString += `searchValue=${searchValue}&`
  }
  if (orderTarget !== undefined && orderTarget !== '') {
    queryString += `orderTarget=${orderTarget}&`
  }
  if (orderValue !== undefined && orderValue !== '') {
    queryString += `searchValue=${encodeURI(orderValue)}&`
  }
  return fetch(`${process.env.BASE_API}/manage/account/list/${queryString}` + Date.now(), requestOptions).then(handleResponse)
}

/**
 * @param {number} accountId
 */
function getAccountGolfClubs(accountId) {
  let requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cache: 'no-cache'
  }
  return fetch(`${process.env.BASE_API}/manage/account/clubs/${accountId}`, requestOptions).then(handleResponse)
}

function handleResponse (response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.logout()
        router.push('/login')
      }
      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }
    return data
  })
}



// WEBPACK FOOTER //
// ./src/router/aplManagerRouter.js